/**
 * BenchmarkSelect: which benchmark's tree the Data refinery page shows.
 * The pick lives in the URL (`benchmark`), so a link opens on the same
 * tree. A chip marks the benchmark the scoring night scores.
 */

import type { RefineryBenchmark } from '@/api/generated/model'
import { Badge } from '@/components/ui/badge'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { REFINERY_COPY } from './rows'

interface BenchmarkSelectProps {
  benchmarks: RefineryBenchmark[]
  value: string
  onChange: (benchmark: string) => void
}

export function BenchmarkSelect({ benchmarks, value, onChange }: BenchmarkSelectProps): React.JSX.Element {
  const scored = benchmarks.some((benchmark) => benchmark.id === value && benchmark.scored)
  return (
    <div className="flex items-center gap-2">
      {scored && <Badge variant="outline">{REFINERY_COPY.scored}</Badge>}
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger aria-label={REFINERY_COPY.benchmark} className="h-8 w-56 text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {benchmarks.map((benchmark) => (
            <SelectItem key={benchmark.id} value={benchmark.id}>
              {benchmark.display}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
